<script lang="ts">
    import { localizationInfoProviderToken } from "@/tokens";
    import cn from "classnames";
    import { createEventDispatcher } from "svelte";
    import { container } from "tsyringe";

    import Button from "@components/Buttons/Button.svelte";
    import T from "@components/T.svelte";

    import ReviewEntity from "../entities/ReviewEntity";

    export let namespace: string;
    export let review: ReviewEntity;
    export let isTranslationLoading: boolean;
    export let showTranslation: boolean;

    const dispatch = createEventDispatcher();
    const localizationInfo = container.resolve(localizationInfoProviderToken);

    const seeTranslation = (event: Event) => {
        event.preventDefault();
        event.stopPropagation();

        dispatch("seeTranslation", {
            reviewId: review.id,
            targetLanguage: localizationInfo.getLanguageIsoCode(),
        });
    };
</script>

<Button variant="link" class="gw-rv-see-translation" on:click={seeTranslation}>
    <span
        class={cn(
            `gw-rv-see-translation--${
                isTranslationLoading
                    ? "translating"
                    : showTranslation
                    ? "translated"
                    : "untranslated"
            }`
        )}
    >
        {#if isTranslationLoading}
            <T {namespace} translationKey="translating" />
        {:else if showTranslation}
            <T {namespace} translationKey="see_original" />
        {:else}
            <T {namespace} translationKey="see_translation" />
        {/if}
    </span>
</Button>

<style lang="postcss">
    :global(.gw-btn.gw-button.gw-rv-see-translation) {
        font-size: var(--gw-font-size-sm);
        font-weight: 500;
    }

    .gw-rv-see-translation {
        &--translated,
        &--untranslated {
            color: var(--gw-theme-main-text-primary);
        }

        &--translating {
            color: rgb(153, 153, 153);
        }
    }
</style>
